/* Umya · Ficha de producto.
   Tres cosas, ninguna imprescindible para comprar: si esto no carga, la ficha
   sigue funcionando entera (los desplegables son <details> nativos y el boton
   de comprar es el de Dawn).

   1. "Not your size?" abre el desplegable de la guia y lleva la vista hasta el.
   2. Los videos de YouTube no se cargan hasta que alguien los pulsa.
   3. Barra de compra fija en movil, que aparece cuando el boton de arriba
      sale de pantalla.
*/
(function () {
  'use strict';

  /* --- 1. el enlace de la talla abre la guia de abajo --- */

  document.addEventListener('click', function (evento) {
    var enlace = evento.target.closest('[data-umya-abre-guia]');
    if (!enlace) return;

    var destino = document.querySelector(enlace.getAttribute('href'));
    if (!destino) return;

    evento.preventDefault();
    var caja = destino.querySelector('[data-umya-guia]');
    if (caja) caja.open = true;

    var suave = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var antes = window.scrollY;
    destino.scrollIntoView({ behavior: suave, block: 'start' });

    // Red de seguridad: hay navegadores y ajustes de sistema que se comen el
    // desplazamiento animado y lo dejan en nada. Si a los 250 ms la pagina no
    // se ha movido, se salta sin animacion: llegar importa mas que el viaje.
    if (suave === 'smooth') {
      window.setTimeout(function () {
        if (Math.abs(window.scrollY - antes) < 4) {
          destino.scrollIntoView({ block: 'start' });
        }
      }, 250);
    }
  });

  /* --- 2. videos que solo se cargan al pulsarlos --- */

  /* El video diferido se mudo a umya-video.js: el guion viaja con el
     fragmento, para que tambien funcione fuera de la ficha de joya. */

  /* --- 3. la talla obligatoria de Choose your stone, obligatoria de verdad ---

     El campo lleva 'required' desde el primer dia y el navegador lo daba por
     invalido, pero la pieza entraba igual en el carrito con la talla vacia:
     Dawn no envia el formulario, lo intercepta y manda el pedido por su
     cuenta, asi que la validacion del navegador nunca llegaba a ejecutarse.
     Es justo el fallo que perseguiamos evitar: Ushas recibe un encargo a
     medida sin saber de que talla, y toca perseguir a la clienta por correo.

     Este vigia va en captura sobre el documento: se ejecuta antes que el de
     Dawn, pase lo que pase, y corta el envio ahi mismo. */

  document.addEventListener(
    'click',
    function (evento) {
      var boton = evento.target.closest('[name="add"]');
      if (!boton) return;

      var formulario =
        document.getElementById(boton.getAttribute('form') || '') || boton.closest('form');
      if (!formulario || formulario.checkValidity()) return;

      evento.preventDefault();
      evento.stopPropagation();

      // El campo vive fuera del <form> y se engancha con el atributo 'form',
      // asi que hay que buscarlo entre los elementos del formulario y no
      // dentro de su marcado.
      var campo = null;
      for (var i = 0; i < formulario.elements.length; i++) {
        if (formulario.elements[i].hasAttribute('data-umya-talla-obligatoria')) {
          campo = formulario.elements[i];
          break;
        }
      }
      if (campo && campo.dataset.umyaMensaje) campo.setCustomValidity(campo.dataset.umyaMensaje);
      formulario.reportValidity();
    },
    true
  );

  document.addEventListener('input', function (evento) {
    var campo = evento.target.closest('[data-umya-talla-obligatoria]');
    if (campo) campo.setCustomValidity('');
  });

  /* --- 4. barra de compra en movil --- */

  var barra = document.querySelector('[data-umya-barra]');
  if (!barra) return;

  var seccion = barra.dataset.seccion;

  // El boton se busca cada vez, no se guarda: Dawn vuelve a pintar el bloque
  // de compra al elegir variante, y el nodo que se hubiera guardado al cargar
  // se queda huerfano fuera del documento (asi fallaba la primera version:
  // el vigia observaba un boton que ya no estaba en la pagina).
  function botonReal() {
    var formulario = document.getElementById(barra.dataset.form);
    return (
      (formulario && formulario.querySelector('[name="add"]')) ||
      document.querySelector('#ProductSubmitButton-' + seccion)
    );
  }

  if (!botonReal()) return;

  var boton = barra.querySelector('[data-umya-barra-boton]');
  if (boton) {
    boton.addEventListener('click', function () {
      // Pulsa el boton de verdad: es el que sabe que variante hay elegida.
      var real = botonReal();
      if (real) real.click();
    });
  }

  barra.hidden = false;

  /* La barra de vista previa de Shopify (solo en el borrador) se pinta pegada
     abajo por encima de todo y tapaba esta entera: se veia funcionar en los
     numeros y no en la pantalla. Se mide su altura y se deja ese hueco. En la
     tienda publicada no existe y el hueco vale 0. */
  function medirHuecoAbajo() {
    var previa = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    var alto = 0;
    if (previa) {
      var caja = previa.getBoundingClientRect();
      // Solo cuenta si esta pegada al fondo de la ventana.
      if (caja.height > 0 && caja.bottom > window.innerHeight - 4) alto = Math.round(caja.height);
    }
    barra.style.setProperty('--umya-hueco-abajo', alto + 'px');
  }

  medirHuecoAbajo();
  window.addEventListener('resize', medirHuecoAbajo, { passive: true });
  // La barra de vista previa se inyecta despues de cargar la pagina.
  setTimeout(medirHuecoAbajo, 1200);
  setTimeout(medirHuecoAbajo, 3000);

  var pendiente = false;

  function repasar() {
    pendiente = false;
    var real = botonReal();
    if (!real) return;
    var caja = real.getBoundingClientRect();
    // Se ensena cuando el boton de arriba ya ha salido por encima.
    barra.classList.toggle('umya-barra--vista', caja.bottom < 0);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(repasar);
    },
    { passive: true }
  );

  window.addEventListener('resize', repasar, { passive: true });
  repasar();

  /* La barra dice lo mismo que el boton de arriba (29-sep-2026: en el iPhone
     de Marcos arriba ponia "Unavailable" y abajo "Add to cart" a la vez). */
  var textoBarra = boton && boton.textContent.trim();
  function copiarEstado() {
    var real = botonReal();
    if (!real || !boton) return;
    var apagado = real.hasAttribute('disabled');
    boton.disabled = apagado;
    boton.textContent = apagado ? real.textContent.trim() : textoBarra;
  }
  var formularioReal = document.getElementById(barra.dataset.form);
  if (formularioReal && 'MutationObserver' in window) {
    new MutationObserver(copiarEstado).observe(formularioReal, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  copiarEstado();

  /* El precio de la barra sigue al de la ficha: en Choose your stone cambia
     al elegir piedra. */
  var precioFicha = document.getElementById('price-' + seccion);
  var precioBarra = barra.querySelector('[data-umya-barra-precio]');

  if (precioFicha && precioBarra && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var valor = precioFicha.querySelector('.price-item--regular, .price-item--sale');
      if (valor) precioBarra.textContent = valor.textContent.trim();
    }).observe(precioFicha, { childList: true, subtree: true, characterData: true });
  }
})();
